import { bool } from 'prop-types';
import DateHelper from '../../../../helpers/date-helper';
import { DatepickerAttention } from './Styled';
const Attention = ({
  hasBottomGap,
  isOverlayShow
}) => /*#__PURE__*/React.createElement(DatepickerAttention, {
  isOverlayShow: isOverlayShow,
  hasBottomGap: hasBottomGap
}, I18n.t('layout.search.datepicker.limitation', {
  days: DateHelper.config.MAX_DAYS_FOR_SEARCH_FROM_NOW
}));
Attention.propTypes = {
  isOverlayShow: bool,
  hasBottomGap: bool
};
export default Attention;